interface IVoucher{
    disponivel: boolean
}

export const instanceOfIVoucher = (object: any): object is IVoucher => {
    return 'disponivel' in object
}

export default IVoucher